module Meevo.Plugins.ServiceCharges {
    "use strict";

    /**
    * Main Section of Client 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ServiceCharges> {
        public increments = [];
        public criteriaForLocationOwned: any = {};
        public coCriteria: any = {};

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings, sectionSecurityKey);
            this.criteriaForLocationOwned = {
                coFilterByLocationId: this.identityService.current().locationId,
                coSearchResultFilter: 1, coSearchType: 1
            };

        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        chargeType(ChargeTypeEnum):boolean {
            switch (ChargeTypeEnum) {
                case Meevo.Model.ChargeTypeEnum.EmployeeFee:
                    return false;

                case Meevo.Model.ChargeTypeEnum.HouseFee:
                    return false;

                case Meevo.Model.ChargeTypeEnum.TicketCharge:
                    return false;

                default:
                    return true;

            }
        }
    }
}